export default "__VITE_ASSET__Pd26xsME__"